import React from 'react';

const TestimonialCard = ({ 
  name, 
  review, 
  rating = 5,
  avatarInitial 
}) => {
  return (
    <div className="bg-white rounded-2xl p-6 shadow-lg border border-orange-100">
      <div className="flex items-center mb-4">
        <div className="w-12 h-12 rounded-full mr-4 bg-gradient-to-br from-orange-400 to-red-400 flex items-center justify-center text-white font-bold text-lg">
          {avatarInitial}
        </div>
        <div>
          <h4 className="font-semibold text-orange-800">{name}</h4>
          <div className="text-yellow-500">
            {'⭐'.repeat(rating)}
          </div>
        </div>
      </div>
      <p className="text-gray-700 italic">"{review}"</p>
    </div>
  );
};

export default TestimonialCard;
